
export const sendAuth =  {
    data: () => ({
        data: null
    }),
   methods: {
      sendLoginSocial ($profile, $url, $result = null) {

         var params = new URLSearchParams();

         if ($profile.access_token !== undefined) {
             params.append('access_token', $profile.access_token);
         }

         if ($profile.token !== undefined) {
             params.append('token', $profile.token);
         }

         if ($profile.credential !== undefined) {
             params.append('credential', $profile.credential);
         }

         if ($profile.email !== undefined) {
             params.append('email', $profile.email);
         }
         if ($profile.first_name !== undefined) {
             params.append('first_name', $profile.first_name);
         }
         if ($profile.last_name !== undefined) {
             params.append('last_name', $profile.last_name);
         }
         // if ($profile.userID !== undefined) {
         //     params.append('uid', $profile.userID);
         // }
         if ($profile.finish_registration) {
             params.append('finish_registration', $profile.finish_registration);
         }
         if ($profile.role !== undefined) {
             params.append('role', $profile.role);
         }

         this.$http.postCsrf($url, params)
             .then(response => {
                this.data = response.data;
             })
             .catch(error => {
                console.error(error);
             })
             .finally(() => {
                 if ($result !== null) {
                     $result(this.data)
                 }
             });
      }
   }
};
